import { BaseKey, CrudFilters, useShow } from '@refinedev/core';
import { Modal, Tabs } from "antd";
import TabPane from "antd/es/tabs/TabPane";
import { ChildForm } from 'interfaces/schemaDB';
// import Cw8Edit from './Cw8Edit';
// import Cw8List from './Cw8List';

import { Typography } from 'antd';
import { useModalForm } from '@refinedev/antd';

// import { FieldDB } from 'src/interfaces/schemaDB';

// import { Select } from 'antd';
import Cw8Edit from 'components/cw8/Cw8Edit';
import Cw8List from 'components/cw8/Cw8List';
import Cw8Create from 'components/cw8/Cw8Create';
// import SeccionInfografia from 'src/pages/infografias/SeccionInfografia';

const { Title } = Typography;
interface EditProductoProps{
    resourceLabel ?: string
    resourceName :string
    id : BaseKey | undefined 
    childrenForms : ChildForm[]
}

interface BtnExtraProps{
    childrenForms : ChildForm[]
}



const EditBibliotecaVirtual = ({resourceLabel, resourceName, id, childrenForms} : EditProductoProps ) => {


    
    let ID : any = id



    const resourceNameSeccion = "autorXDocumento"
    const filterList : CrudFilters  =  [
        {
            field: "id",
            operator: "eq",
            value: ID
        },
    ]

    const {         
        modalProps: createModalProps,
        formProps: createFormProps,
        show: openModalCreate} = useModalForm({
            action: "create",
            resource:resourceNameSeccion,
            redirect : false
        }
    );

    const { queryResult } = useShow();
    const { data, isLoading } = queryResult;
    const record = data?.data;    
        
    const {
        modalProps: editModalProps,
        formProps: editFormProps,
        show: editModalShow,
    } = useModalForm({
        action: "edit"
        , resource: 'autorXDocumento'
        , redirect: false
        , meta: {
            method: "put"
        }
    });

    if(childrenForms.length == 0){
        return(
            <Cw8Edit resourceName = {resourceName} childrenForms={childrenForms} ></Cw8Edit>
        )
    }else{
        return(
            <>
            
            <Title level={4}>Documento {record?record["id"]:""}</Title>
            
            <Tabs defaultActiveKey="0" 
            >
                <TabPane tab={"Documento"} key={0}>
                    <Cw8Edit resourceName={"bibliotecaVirtual"} />
                </TabPane>               
                
                {/* <TabPane tab={resourceLabel?resourceLabel:"General"} key="1">
                    <Cw8Edit resourceName = {resourceName}  childrenForms={childrenForms}></Cw8Edit>
                </TabPane> */}

                {
                    childrenForms.filter( item => !item.url ).map( (child, index) =>(
                        <TabPane tab={child.title} key={index+2}>
                            <Cw8List
                                resourceName = {child.resourceName}
                                titleList = {child.title}
                                filterList ={[
                                    {
                                        field: child.field,
                                        operator: "eq",
                                        value: ID
                                    }
                                ]}
                                showCards = {child.showCards?true:false}
                                configCard = {
                                    child.configCard?child.configCard:undefined
                                }
                                createModal = {true}
                                editModal = {true}
                            ></Cw8List>        
                        </TabPane>
                    ))
                }
            </Tabs>   

            <Modal {...createModalProps}>
                <Cw8Create
                    resourceName={resourceNameSeccion}
                    filterList = {filterList}
                    createFormProps = {createFormProps}
                ></Cw8Create>
            </Modal>

            <Modal {...editModalProps}
                title="Editar Infografia"
            >
                <Cw8Edit
                    key={id}
                    resourceName={'bibliotecaVirtual'}
                    editFormProps={editFormProps}
                    idResource={id}
                    modal={true}
                ></Cw8Edit>
            </Modal>

            </>            
        )
    }
        
}

export default EditBibliotecaVirtual
